<mat-toolbar>
    <ng-content></ng-content>
</mat-toolbar>
